import {
  NotFoundComponentHeroDiv,
  NotFoundComponentMainDiv,
} from "../../styles/notfoundpagestyles/notfoundcomponentstyles";
import Footer from "../reusable/footer/footer";
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent";
import HeaderComponent from "../reusable/header/header";

const NotFoundComponent = () => {
  return (
    <NotFoundComponentMainDiv>
      <div className="header-holder">
        <HeaderComponent />
      </div>
      <NotFoundComponentHeroDiv>
        <div>
          <div className="notfound-hero-container">
            <div>
              <div>
                <div className="notfound-404-text-container">
                  <h1>404</h1>
                </div>
              </div>
              <div className="notfound-header-container">
                <div>
                  <div className="notfound-header-text-container">
                    <h1>We lost this page</h1>
                  </div>
                </div>
                <div>
                  <div className="notfound-header-text-container">
                    <p>
                      We searched high and low but couldn't find what you're
                      looking for. Let's find a better place for you to go.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div>
                <ButtonComponent title="Go home" link="/" />
              </div>
            </div>
          </div>
        </div>
      </NotFoundComponentHeroDiv>

      <Footer />
    </NotFoundComponentMainDiv>
  );
};
export default NotFoundComponent;
